/**
 * Netflix Party is now Teleparty
 *
 * Ships web/detect_bundled.js — a script whose entire purpose is letting Teleparty's
 * own site detect the extension. It's exposed to <all_urls>, so any page can use the
 * same mechanism.
 *
 * Manifest verified against version 5.7.5.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'oocalimimngaihdkbihfgmpkcpnmlaoa';

export const teleparty: ExtensionDefinition = {
  id: ID,
  name: 'Netflix Party is now Teleparty',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 9_000_000,
  notes:
    'Ships a purpose-built detection script exposed to every origin, not just its own site.',
  signals: [
    {
      id: 'war-detect-bundled',
      kind: 'web-accessible-resource',
      description:
        'Fetch web/detect_bundled.js — the extension\'s own detection helper, exposed to <all_urls>.',
      weight: 1,
      run: () => probeFetch(ID, 'web/detect_bundled.js'),
    },
    {
      id: 'war-chat-html',
      kind: 'web-accessible-resource',
      description: 'Fetch html/chat.html — the watch-party chat UI.',
      weight: 0.5,
      run: () => probeFetch(ID, 'html/chat.html'),
    },
  ],
};
